/* Validates the file from the input field
 *
 * @param {string} idOfInputElement id of input element
 * @param {any} allowedInputs JSON object as dictionary allowed file extensions and file size in bytes
 * @callback errorCallback A call back function where the error message from validation is passed into.
 */
function validateFileTypeAndSize(idOfInputElement, allowedInputs, errorCallback) {
    $('#' + idOfInputElement).on('change', function () {
        var file = $('#' + idOfInputElement)[0].files[0];

        if (!file) {
            return; // no file to validate
        }

        errorCallback(
            validateFileSizeAndType(
                file,
                allowedInputs));
    });
}

function validateFileSizeAndType(file, allowedInputs) {
    var fileNameSplit = file.name.split('.');
    var fileExtension = fileNameSplit.slice(-1)[0];
    var size = parseFloat(file.size).toFixed(2);

    for (var extension in allowedInputs) {
        if (allowedInputs.hasOwnProperty(extension)) {
            if (extension.toUpperCase() === fileExtension.toUpperCase()) {
                if (size > allowedInputs[extension]) {
                    return "The file '" + file.name + "', size ("
                        + displayNumberOfBytesAsKilobytes(size) + "kB) should be less than "
                        + displayNumberOfBytesAsKilobytes(allowedInputs[extension]) + "kB.";
                }

                return "";
            }
        }
    }

    return "Your file '" + file.name + "' has the extension of '" + fileExtension + "' which is not supported.";
}

function displayNumberOfBytesAsKilobytes(numberOfBytes) {
    return Math.floor(numberOfBytes / 1000);
}

if (typeof exports !== 'undefined') {
    module.exports = validateFileSizeAndType;
}